import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";
import { profileType } from "@utils/enum";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Shipment Value (USD)", two_table_header: "Total Shipment Value (USD)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
];
export const defaultData = {
  name: "Vietnam Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2020-01-01",
  isImpExpGraph: true,
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("intelSearchVietnamExportLatestArrivalDate"),
    getSearchResult: getApiUrl("intelSearchVietnamExport"),
    getAnalyticsData: getApiUrl("analytics/intelAnalyticsVietnamExport"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_vietnam_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_vietnam_exports"),
    getShipmentByID: getApiUrl("intelSearchVietnamExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfVietnamExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/intelAnalyticsVietnamExportViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchVietnamExportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.vn_export.country_small,
  countryCaps: globalCountryDetails.vn_export.country_caps,
  product_id: globalCountryDetails.vn_export.product_id,
  compare_product_id: globalCountryDetails.vn_export.compareProduct,
  country_CamelCase: globalCountryDetails.vn_export.product_id,
  countryCode: globalCountryDetails.vn_export.countryCode,
  countryType: globalCountryDetails.vn_export.countryType,
  manyCountryType: globalCountryDetails.vn_export.manyCountryType,
  countryTypeCode: globalCountryDetails.vn_export.countryTypeCode,
  redirectionID: globalCountryDetails.vn_export.redirectionID,
  analyticsCountryID: globalCountryDetails.vn_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.vn_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    teu: "teu",
    value: "shipmentValue",
    sixDigitHsCode: "sixDigitHsCode",
    portOfLading: "portOfLading",
    portOfUnlading: "portOfUnladingCountryRegion",
    productCategory: "productCategory",
  },
  filterObj: {
    shipperName: "shipperName",
    shipperType: "shipperType",
    shipperProvinceRegion: "shipperProvinceRegion",
    shipperDistrict: "shipperDistrict",
    consigneeName: "consigneeName",
    consigneeType: "consigneeType",
    consigneeCountryRegion: "consigneeCountryRegion",
    portOfUnladingCountryRegion: "portOfUnladingCountryRegion",
    countryOfExportRegion: "countryOfExportRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    portOfLading: "portOfLading",
    customsHouseName: "customsHouseName",
    customsClearanceWarehouseName: "customsClearanceWarehouseName",
    hsCode: "hsCode",
    shipmentValue: "shipmentValue",
    transportMode: "transportMode",
    incoterm: "incoterm",
    paymentMethod: "paymentMethod",
    typeOfExportCode: "typeOfExportCode",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",

    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    containers: "containers",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    containers: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    consigneeCountryRegion: "consigneeCountry",
    shipperProvinceRegion: "shipperProvince",
    portOfUnladingCountryRegion: "portOfUnladingCountry",
    countryOfExportRegion: "countryOfExport",
    countryOfDestinationRegion: "countryOfDestination",

    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    shipperName: [],
    shipperType: [],
    shipperProvinceRegion: [],
    shipperDistrict: [],
    consigneeName: [],
    consigneeType: [],
    consigneeCountryRegion: [],
    portOfUnladingCountryRegion: [],
    countryOfExportRegion: [],
    countryOfDestinationRegion: [],
    portOfLading: [],
    customsHouseName: [],
    customsClearanceWarehouseName: [],
    hsCode: [],
    sections: [],
    shipmentValue: [],
    transportMode: [],
    incoterm: [],
    paymentMethod: [],
    typeOfExportCode: [],
    derivedConsigneeMasterName: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],

    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    shipperName: false,
    shipperType: false,
    shipperProvinceRegion: false,
    shipperDistrict: false,
    consigneeName: false,
    consigneeType: false,
    consigneeCountryRegion: false,
    portOfUnladingCountryRegion: false,
    countryOfExportRegion: false,
    countryOfDestinationRegion: false,
    portOfLading: false,
    customsHouseName: false,
    customsClearanceWarehouseName: false,
    hsCode: false,
    sections: false,
    shipmentValue: false,
    transportMode: false,
    incoterm: false,
    paymentMethod: false,
    typeOfExportCode: false,
    derivedConsigneeMasterName: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,

    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "22", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "23", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "1", key: "shipperName", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "5", key: "consigneeName", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "2", key: "shipperType", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Shipper Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Province", categoryName: "shipperDetails", eventKey: "3", key: "shipperProvinceRegion", altKey: "shipperProvince", type: filterType.localizeFilter, label: "Shipper Province", viewAllPlaceHolder: "Search in Shipper Province Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper District", categoryName: "shipperDetails", eventKey: "4", key: "shipperDistrict", type: filterType.normalFilter, label: "Shipper District", viewAllPlaceHolder: "Search in Shipper District Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: "consigneeDetails", eventKey: "6", key: "consigneeType", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Consignee Type Filter", emptyFilterText: "", searchFilterString: "" },
    // { heading: "Filter by Consignee Country", categoryName: "consigneeDetails", eventKey: "9", key: "consigneeCountryRegion", altKey: "consigneeCountry", type: filterType.localizeFilter, label: "Consignee Country", viewAllPlaceHolder: "Search in Consignee Country Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "9", key: "consigneeCountryRegion", altKey: "consigneeCountry", type: filterType.localizeFilter, label: "Country Of Import", viewAllPlaceHolder: "Search in Country Of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "9", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country Of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Unlading", categoryName: "ports", eventKey: "10", key: "portOfUnladingCountryRegion", altKey: "portOfUnladingCountry", type: filterType.localizeFilter, label: "Port Of Unlading", viewAllPlaceHolder: "Search in Port Of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Lading", categoryName: "ports", eventKey: "11", key: "portOfLading", type: filterType.normalFilter, label: "Port Of Lading", viewAllPlaceHolder: "Search in Port Of Lading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs House Name", categoryName: "customsDetails", eventKey: "12", key: "customsHouseName", type: filterType.normalFilter, label: "Customs House Name", viewAllPlaceHolder: "Search in Customs House Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Clearance Warehouse Name", categoryName: "customsDetails", eventKey: "13", key: "customsClearanceWarehouseName", type: filterType.normalFilter, label: "Customs Clearance Warehouse Name", viewAllPlaceHolder: "Search in Customs Clearance Warehouse Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "9", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Type to Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Type to Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "15", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "17", key: "shipmentValue", type: filterType.boxFilter, label: "Value (USD)", viewAllPlaceHolder: "Search in Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "18", key: "transportMode", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Incoterm Filter", categoryName: "freightType", eventKey: "19", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
    { heading: "Filter by Type of Payment Method Filter", categoryName: "freightType", eventKey: "20", key: "paymentMethod", type: filterType.normalFilter, label: "Payment Method", viewAllPlaceHolder: "Search in Payment Method Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Type of Export Code Filter", categoryName: "freightType", eventKey: "21", key: "typeOfExportCode", type: filterType.normalFilter, label: "Type of Export Code", viewAllPlaceHolder: "Search in Type of Export Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },

    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: false, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "declaration_number", label: "Declaration Number" },
    { key: "derived_hs_code", label: "HS Code" },
    { key: "product_description_english", label: "Product Description" },
    { key: "product_description_vietnamese", label: "Product Description Vietnamese" },
    { key: "derived_shipper_master_name", label: "Shipper Standardized Name" },
    { key: "derived_shipper_name_english", label: "Shipper Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "consignee_name", label: "Consignee Name" },
    { key: "bill_of_lading_number", label: "Bill of lading Number" },
    { key: "derived_consignee_address", label: "Consignee Address" },
    { key: "shipper_address_english", label: "Shipper Address" },
    { key: "invoice_number", label: "Invoice Number" },
    { key: "derived_custom_branch_name", label: "Custom House Name" },
    { key: "customs_clearance_warehouse_name", label: "Custom Clearance Warehouse Name" },
    { key: "derived_vessel_name", label: "Vessel Name" },
    { key: "shipper_registration_number", label: "Shipper Registration Number" },
  ],
  shipmentSorting: [
    { columnKey: "corrected_declaration_date", value: "date", isDefault: true },
    { columnKey: "derived_shipment_value_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: true },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: false },
  ],
  sortKeyMap: {
    date: "corrected_declaration_date",
    shipment_value: "derived_shipment_value_usd",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "consigneeCountryRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "consignee_country", filterKey: "consigneeCountryRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading" },
    // { key: 'consignee_district', filterKey: 'consigneeDistrict', label: 'Consignee Districts', type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: 'shipper_district' },
    { key: "shipper_province", filterKey: "shipperProvinceRegion", label: "Shipper Provinces", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "consignee_country" },
    { key: "shipper_district", filterKey: "shipperDistrict", label: "Shipper Districts", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "port_of_lading", filterKey: "portOfLading", label: "Ports of Lading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading", profileType: redirectingProfileEnum.portOfLading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "port_of_unlading", filterKey: "portOfUnladingCountryRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_lading", profileType: redirectingProfileEnum.portOfUnlading.key, isFavourite: true, profileTypeKey: profileType.ports },
    { key: "custom_house", filterKey: "customsHouseName", label: "Customs Houses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "port_of_unlading" },
    { key: "warehouse_name", filterKey: "customsClearanceWarehouseName", label: "Custom Clearance Warehouses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "consignee_country" },
    // { key: 'vessel_name', filterKey: 'vesselName', label: 'Vessels', type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: 'consignee_country' },
    { key: "mode_of_transport", filterKey: "transportMode", label: "Modes of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "consignee_country" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "trade_lading_to_unlading", filterKey1: "portOfLading", filterKey2: "portOfUnladingCountryRegion", label: "Trade Routes (Port Of Lading → Port Of Unlading)", headerOne: "Port Of Lading", headerTwo: "Port Of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    // { key: "trade_custom_house_to_unlading", filterKey1: "customsHouseName", filterKey2: "portOfUnladingCountryRegion", label: "Trade Route (Custom House Name → Port Of Unlading)", headerOne: "Custom House Name", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    // { key: 'trade_shipper_province_to_consignee_district', filterKey1: 'shipperProvinceRegion', filterKey2: 'consigneeDistrict', label: 'Trade Routes (Shipper Province → Consignee District)', headerOne: 'Shipper Province', headerTwo: 'Consignee District', filterOne: 'filterField1', filterTwo: 'filterField2', keyOne: 'field1Country', keyTwo: 'field2Country', cityOne: 'field1', cityTwo: 'field2', keyOneCountryCode: 'field1CountryCode',  keyTwoCountryCode: 'field2CountryCode', type: analyticsType.topTwo, showTrends: true, grpType: 'multi', showlevelTwo: true, defaultKey: 'derived_shipper_master_name' },
    // { key: "trade_lading_to_consignee_country", filterKey1: "portOfLading", filterKey2: "consigneeCountryRegion", label: "Trade Route (Port of Lading → Country of Import)", headerOne: "Port of Lading", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    // { key: "trade_custom_house_to_consignee_country", filterKey1: "customsHouseName", filterKey2: "consigneeCountryRegion", label: "Trade Routes (Custom House Name → Country of Import)", headerOne: "Custom House Name", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "corrected_declaration_date", name: "Declaration Date", selector: "corrected_declaration_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_hs_code", name: "HS Code", selector: "derived_hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description_english", name: "Product Description", selector: "product_description_english", tooltipValue: "product_description_english", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "product_description_vietnamese", name: "Product Description Vietnamese", selector: "product_description_vietnamese", tooltipValue: "product_description_vietnamese", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "shipment_quantity", name: "Quantity", selector: "shipment_quantity", secondarySelector: "derived_shipment_quantity_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipper_master_name", name: "Shipper Name", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "derived_consignee_country", name: "Consignee Country", selector: "derived_consignee_country", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipment_value_usd", name: "Shipment Value (USD)", selector: "derived_shipment_value_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Arrival Date", value: "arrival_date", dateFormat: true, monthFormat: false },
        { label: "Approved Clearance Date", value: "approved_clearance_date", dateFormat: true, monthFormat: false },
        { label: "Date of Declaration", value: "corrected_declaration_date", dateFormat: true, monthFormat: false },
        { label: "Invoice Date", value: "invoice_date", dateFormat: true, monthFormat: false },
        { label: "Declaration Number", value: "declaration_number" },
        { label: "Bill of Lading Number", value: "bill_of_lading_number", capitalize: "true" },
        { label: "Invoice Number", value: "invoice_number" },
        { label: "Modes of Transportation", value: "derived_mode_of_transportation" },
        { label: "Incoterm", value: "incoterm", tooltip: true, tooltipField: "derived_incoterm_description", capitalize: true },
        { label: "Payment Method", value: "payment_method", tooltip: true, tooltipField: "derived_payment_method", capitalize: true },
        { label: "Type of Export", value: "type_of_export_code", tooltip: true, tooltipField: "derived_type_of_export_code" },
        { label: "HS Code", value: "derived_hs_code" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Shipper Name", value: "derived_shipper_name_english" },
        { label: "Shipper Name (Vietnamese)", value: "shipper_name" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Shipper Registration Number", value: "shipper_registration_number" },
        { label: "Shipper Type", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        { label: "Shipper Address", value: "shipper_address_english", isReadMore: true, readMoreLength: 45 },
        { label: "Shipper Phone Number", value: "shipper_phone_number" },
        { label: "Shipper Province", value: "derived_shipper_province" },
        { label: "Shipper District", value: "derived_shipper_district" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Port of Lading", value: "lading_country_combined", tooltip: true, tooltipField: "port_of_lading_code", tooltipPrefix: "Port Of Lading Code: ", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Consignee District", value: "consignee_district" },
        { label: "Consignee City", value: "consignee_city" },
        // { label: "Consignee Country", value: "derived_consignee_country" },
        { label: "Consignee Address", value: "derived_consignee_address", isReadMore: true, readMoreLength: 45 },
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Port of Unlading", value: "unlading_country_combined", tooltip: true, tooltipField: "port_of_unlading_code", tooltipPrefix: "Port Of Unlading Code: ", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Customs House Name", value: "derived_customs_branch_name", capitalize: "true", tooltip: true, tooltipField: "derived_custom_branch_name_abv" },
        { label: "Custom Clearance Warehouse Name", value: "customs_clearance_warehouse_name", capitalize: true, tooltip: true, tooltipField: "customs_clearance_warehouse_code" },
      ],
    },
    {
      id: 5,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [{ label: "Vessel Name", value: "derived_vessel_name", capitalize: "true" }],
    },
    {
      id: 6,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "HS Code", value: "derived_hs_code" },
        { label: "Product Description", value: "product_description_english" },
        { label: "Product Description (Vietnamese)", value: "product_description_vietnamese" },
        { label: "Declaration Quantity", value: "total_quantity", dynamicUnit: true, unitField: "total_quantity_unit", isCommaFormat: true },
        { label: "Shipment Quantity", value: "shipment_quantity", dynamicUnit: true, unitField: "derived_shipment_quantity_unit", isCommaFormat: true },
        { label: "Declaration Gross Weight", value: "total_gross_weight", valueSuffix: " kg", isCommaFormat: true },
        { label: "Declaration Invoice Value", value: "derived_total_invoice_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Shipment Value", value: "derived_shipment_value_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Taxable Value", value: "derived_total_taxable_value_usd", valuePrefix: "USD ", isCommaFormat: true },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "consignee_country",
  twoColumnMapping: {
    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    port_of_lading: "Ports of Lading",
    port_of_unlading: "Ports of Unlading",
    consignee_country: "Countries of Import",
    shipper_district: "Shipper Districts",
    shipper_province: "Shipper Provinces",
    custom_house: "Custom Houses",
    warehouse_name: "Custom Clearance Warehouses",

    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    trade_lading_to_unlading: "Trade Routes (Port Of Lading → Port Of Unlading)",
    // trade_custom_house_to_unlading: "Trade Routes (Custom House Name → Port Of Unlading)",
    // trade_lading_to_consignee_country: "Trade Routes (Port of Lading → Country of Import)",
    // trade_custom_house_to_consignee_country: "Trade Routes (Custom House Name → Country of Import)",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const VietnamExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default VietnamExportSearch;
